import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_up",
  "use": "arrow_up-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol viewBox=\"0 0 12 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_up\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.00004 4.17517L9.35359 7.52872L8.64648 8.23583L6.00004 5.58938L3.35359 8.23583L2.64648 7.52872L6.00004 4.17517Z\" fill=\"#C79E6B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol